import React, { useState, useEffect } from "react";
import { useForm, useFieldArray } from "react-hook-form";
import { Link } from "react-router-dom";
import { DatePicker } from "antd";
import Select from "react-select";
import {
  Plus,
  Trash2,
  RotateCcw,
  Check,
} from "feather-icons-react/build/IconComponents";
import "../../../style/css/sales-invoice-terminal.css";
import {
  useTerminalChrome,
  TermCmdBar,
  TermColumns,
  TermStatusBar,
} from "../terminal/TerminalChrome";
import toast from "react-hot-toast";
import { ProductClass } from "../../../core/json/Product";
import { getUnitList } from "../../../services/MasterApiServices";
import { Controller } from "react-hook-form";
import dayjs from "dayjs";
import {
  getStockByBranch,
  addEditStock,
} from "../../../services/OpeningStockApiServices";
import { OpeningStockDetail } from "../../../core/json/OpeningStockDetail";
import { OpeningStockMaster } from "../../../core/json/OpeningStockMaster";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchUnit,
  fetchProduct,
  fetchSettings,
} from "../../../redux/userSetting";
import { FinancialYear } from "../../../core/json/FinancialYear";

const OpeningStockModal = ({ mode, data, handleClose, handleRefresh }) => {
  const {
    register,
    setValue,
    handleSubmit,
    control,
    watch,
    formState: { errors },
  } = useForm({
    defaultValues: {
      date: dayjs().format("YYYY-MM-DD"),
    },
  });

  const [unitData, setunitData] = useState([]);
  const [products, setProducts] = useState([]);
  const [branchData, setBranchData] = useState([]);
  const { branch } = useSelector((state) => state.branchlist);
  const { userId } = useSelector((state) => state.userauth);
  const dispatch = useDispatch();
  const [isRowAdded, setIsRowAdded] = useState(false);
  const [decimalpoints, setDecimalPoints] = useState(2);
  const { branchsettings } = useSelector((state) => state.settings);
  const { BranchByUser } = useSelector((state) => state.userBranch);

  useEffect(() => {
    dispatch(fetchUnit());
    dispatch(fetchProduct(branch));
    dispatch(fetchSettings(branch));
    const match = settingList?.currencyFormat?.toString()?.match(/\.0+/);
    const currfmt = match ? match[0]?.length - 1 : 0;
    setDecimalPoints(currfmt);
  }, []);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });
  const { productList, unitList, settingList } = useSelector(
    (state) => state?.usersetting
  );

  const handleBranchList = async () => {
    try {
      const formattedBranch = BranchByUser?.map((obj) => ({
        label: obj?.branch?.name,
        value: obj?.branch?.guid,
      }));

      setBranchData(formattedBranch);
    } catch (error) {
      console.error(
        "Error fetching unit",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  const handleUnitList = async () => {
    try {
      const formattedUnit = unitList?.map((unit) => ({
        label: unit?.name,
        value: unit?.guid,
      }));
      setunitData(formattedUnit);
    } catch (error) {
      console.error(
        "Error fetching unit",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  const handleEachProductfetch = async (selectedOption, index) => {
    setValue(`items[${index}].product`, selectedOption.value);

    try {
      const productData = await getSingleProduct(selectedOption.value);

      setValue(`items[${index}].code`, productData?.code || 0);
      // setValue(`items[${index}].hsnCode`, productData?.hsnCode || 0);
      setValue(`items[${index}].unit`, productData?.unit || 0);
      setValue(`items[${index}].price`, productData?.cost || 0);
    } catch (error) {
      console.error(
        "Error fetching product by GUID:",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  function handleRemove(index) {
    if (fields.length > 1) {
      remove(index);
    } else {
      toast.error("At least one row entry is required");
    }
  }
  async function getSingleProduct(guid) {
    try {
      const filteredData = productList?.find(
        (product) => product.guid === guid
      );
      return filteredData;
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  }

  const handleEntryNo = async () => {
    try {
      const response = await getStockByBranch(branch);
      const stockData = Array.isArray(response) ? response : [];

      // an entry with a null / non-numeric entryNo used to throw (leaving the
      // no. blank -> saved as "0") or turn the max into NaN (saved as "NaN");
      // both repeat on every add and collide with the earlier save
      const maxno = stockData
        .map((data) => parseInt(String(data?.entryNo ?? "").replace(/\D/g, ""), 10))
        .filter((n) => Number.isFinite(n))
        .reduce((max, num) => Math.max(max, num), 0);

      let counter = maxno + 1;

      setValue(`no`, counter);
    } catch (error) {
      console.error(
        "Failed to fetch opening stock",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };
  const handleAddRow = () => {
    append({
      batch: "0",
      quantity: "0",
      unit: "",
      product: null,
    });
  };
  useEffect(() => {
    if (mode === "add") {
      handleEntryNo();
      if (!isRowAdded && fields?.length === 0) {
        handleAddRow();
        setIsRowAdded(true);
      }
    }
    handleBranchList();
    handleProductsList();
    handleUnitList();
  }, []);
  function resetmodal() {
    if (mode === "edit" && data) {
      setValue("no", data?.entryNo);
      setValue("date", dayjs(data?.date));
      setValue("remarks", data?.remarks);
      setValue("referenceNo", data?.referenceNo);
      setValue(
        "items",
        data?.openingStockDetail?.map((detail) => ({
          product: detail?.product?.guid,
          batch: detail?.batch,
          unit: detail?.unit?.guid,
          quantity: detail?.quantity,
          price: detail?.price,
        }))
      );
    }
  }

  useEffect(() => {
    resetmodal();
  }, [data, setValue]);

  async function getUnitByGuid(guid) {
    const filteredData = unitList?.filter((unit) => unit.guid === guid);
    return filteredData[0];
  }
  const handleProductsList = async () => {
    try {
      const response = productList || [];

      const formattedProducts = response?.map((product) => ({
        label: product.name,
        value: product.guid,
      }));
      setProducts(formattedProducts);
    } catch (error) {
      console.error(
        "Error fetching products",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  async function getProductByGuid(guid) {
    const filteredData = productList?.filter(
      (product) => product.guid === guid
    );
    return filteredData[0];
  }

  const handleFormSubmit = async (formdata) => {
    // never fall back to entry no. "0" - every such save collides with the last
    if (!formdata?.no || !String(formdata.no).trim()) {
      toast.error("Entry number could not be generated. Please reopen the form.");
      return;
    }
    const objyear = new FinancialYear();
    objyear.guid = branchsettings?.defaultFinancialYearGuID;
    objyear.id = branchsettings?.defaultFinancialYearID;
    const objstock = new OpeningStockMaster();
    // a new entry must go out as id 0 / empty guid; an edit carries the
    // record's own id + guid (a hard-coded id = 1 used to overwrite both)
    if (mode === "edit") {
      objstock.guid = data?.guid;
      objstock.id = data?.id;
    } else {
      objstock.guid = "";
      objstock.id = 0;
    }
    objstock.createdUser = `{${userId?.id}}`;
    objstock.updatedUser = `{${userId?.id}}`;
    objstock.entryNo = formdata.no ? String(formdata.no) : "0";
    objstock.referenceNo = formdata.referenceNo || "";
    objstock.date = formdata.date
      ? dayjs(formdata.date).format("YYYY-MM-DDTHH:mm:ss")
      : null;
    objstock.branch = branch;
    objstock.remarks = formdata.remarks || "";
    objstock.financialYear = objyear;
    const detailObj = formdata?.items?.map((e) => {
      let product;
      const productValue = e.product || e.product.value;

      product = productList?.find((item) => item.guid == productValue);
      const unit = unitList.find((item) => item.guid == e.unit);
      const detail = {
        product,
        unit,
        batch: e.batch,
        quantity: e.quantity,
        price: e.price,
      };

      return detail;
    });
    objstock.openingStockDetail = detailObj;

    try {
      const response = await addEditStock(objstock);
      // success is a literal true (G-2) - a 200 "false" is a failure
      if (response?.data !== true) {
        toast.error(response?.data?.Message || "Not saved - please try again");
      } else {
        toast.success("Success");
        handleRefresh();
        handleClose();
      }
    } catch (error) {
      toast.error(error?.response?.data?.Message || "something went wrong");
      console.error(
        "Error handling :",
        error?.response?.data?.Message || "something went wrong"
      );
    }
  };

  // react-select menus render into this node inside .si-term, so they pick
  // up the terminal's colour tokens like everything else
  const [menuHost, setMenuHost] = useState(null);
  const menuPortalTarget = menuHost;
  const siSelectStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 11000 }),
    menu: (base) => ({ ...base, zIndex: 11000 }),
  };

  // view preferences only - theme, full screen, More row, visible columns
  const chrome = useTerminalChrome("openingStock", {
    batch: true,
  });
  const referenceNo = watch("referenceNo");
  const docDate = watch("date");
  const qtyTotal = (fields || []).reduce(
    (sum, f, i) => sum + (Number(watch(`items[${i}].quantity`)) || 0),
    0
  );

  return (
    <div>
      <div
        className="modal fade show si-term si-term--txn"
        data-si-theme={chrome.theme}
        style={{ display: "block" }}
        tabIndex="-1"
      >
        <div className="modal-dialog si-dialog">
          <div className="modal-content si-content">
            <form
              className="si-form"
              onSubmit={handleSubmit(handleFormSubmit)}
            >
              <div className="si-grid">
                <div className="si-left">
                  {/* ============ COMMAND BAR ============ */}
                  <TermCmdBar
                    chrome={chrome}
                    title="Opening Stock"
                    docNo={watch("no")}
                    state={
                      mode === "edit"
                        ? { key: "edit", label: "Editing" }
                        : { key: "new", label: "New" }
                    }
                    onBack={handleClose}
                  />
                  {/* entry no. is generated - the header shows it */}
                  <input
                    type="text"
                    className="si-offscreen"
                    tabIndex={-1}
                    aria-hidden="true"
                    {...register("no")}
                    required
                    disabled
                  />

                  {/* ============ HEADER FIELDS ============ */}
                  <section className="si-strip">
                    <div className="si-strip-row si-strip-row--auto">
                      <div className="si-fld">
                        <label>
                          Date <span className="si-req">*</span>
                        </label>
                        <Controller
                          control={control}
                          name="date"
                          render={({ field: { onChange, value } }) => (
                            <DatePicker
                              className="si-date"
                              value={value ? dayjs(value) : dayjs()}
                              format="DD-MM-YYYY"
                              onChange={(date) =>
                                onChange(
                                  date ? date.format("YYYY-MM-DD") : null
                                )
                              }
                            />
                          )}
                        />
                      </div>
                      <div className="si-fld">
                        <label>Reference No.</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="—"
                          {...register("referenceNo")}
                          required
                        />
                      </div>
                      <div className="si-fld si-fld--wide">
                        <label>Remarks</label>
                        <input
                          type="text"
                          className="si-in"
                          placeholder="Note for this opening stock"
                          {...register("remarks")}
                        />
                      </div>
                    </div>
                  </section>

                  {/* ============ LINES ============ */}
                  <section className="si-lines">
                    <TermColumns
                      chrome={chrome}
                      columns={[{ key: "batch", label: "Batch" }]}
                    >
                      <button
                        type="button"
                        className="si-iconbtn"
                        onClick={handleAddRow}
                      >
                        <Plus />
                        <span>Add line</span>
                      </button>
                      <button
                        type="button"
                        className="si-iconbtn"
                        onClick={() => resetmodal()}
                      >
                        <RotateCcw />
                        <span>Reset</span>
                      </button>
                    </TermColumns>

                    <div className="si-tablewrap">
                      <table
                        className="si-table"
                        style={{
                          minWidth: `${chrome.tableWidth(594, {
                            batch: 80,
                          })}px`,
                        }}
                      >
                        <thead>
                          <tr>
                            <th style={{ width: "240px" }}>
                              Item <span className="si-req">*</span>
                            </th>
                            <th style={{ width: "70px" }}>
                              Unit <span className="si-req">*</span>
                            </th>
                            <th
                              className={chrome.colClass("batch")}
                              style={{ width: "80px" }}
                            >
                              Batch
                            </th>
                            <th className="n" style={{ width: "70px" }}>
                              Qty <span className="si-req">*</span>
                            </th>
                            <th className="n" style={{ width: "90px" }}>
                              Rate <span className="si-req">*</span>
                            </th>
                            <th
                              style={{ width: "44px" }}
                              aria-label="Line actions"
                            />
                          </tr>
                        </thead>
                        <tbody>
                          {fields?.map((obj, index) => {
                            return (
                              <tr className="si-line" key={index}>
                                <td data-label="Description">
                                  <Controller
                                    control={control}
                                    name={`items[${index}].product`}
                                    rules={{
                                      required: "Product is required",
                                      validate: (value) => {
                                        const selectedProducts = watch(
                                          "items"
                                        )?.map((item) => item.product); // Get all selected products
                                        const isDuplicate =
                                          selectedProducts?.filter(
                                            (product) => product === value
                                          )?.length > 1;
                                        return (
                                          !isDuplicate ||
                                          "Duplicate product selected!"
                                        );
                                      },
                                    }}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        className="si-itemsel"
                                        placeholder="Item name or code"
                                        options={products}
                                        value={products?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) => {
                                          onChange(selectedOption.value);
                                          handleEachProductfetch(
                                            selectedOption,
                                            index
                                          );
                                        }}
                                        menuPortalTarget={menuPortalTarget}
                                        menuPosition="fixed"
                                        styles={siSelectStyles}
                                      />
                                    )}
                                  />
                                  {errors.items &&
                                    errors.items[index]?.product && (
                                      <span className="si-err">
                                        {errors.items[index].product.message}
                                      </span>
                                    )}
                                </td>
                                <td data-label="Unit">
                                  <Controller
                                    control={control}
                                    name={`items[${index}].unit`}
                                    render={({
                                      field: { onChange, value },
                                    }) => (
                                      <Select
                                        classNamePrefix="react-select"
                                        className="si-unitsel"
                                        placeholder="—"
                                        options={unitData}
                                        value={unitData?.find(
                                          (option) => option.value === value
                                        )}
                                        onChange={(selectedOption) => {
                                          onChange(selectedOption.value);
                                        }}
                                        isDisabled={true}
                                      />
                                    )}
                                  />
                                </td>

                                <td className={chrome.colClass("batch")}>
                                  <input
                                    type="text"
                                    className="si-cellin si-cellin--text si-cellin--ro"
                                    {...register(`items[${index}].batch`)}
                                    disabled
                                  />
                                </td>

                                <td className="n">
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="si-cellin"
                                    {...register(`items[${index}].quantity`, {
                                      required: "quantity is required",
                                      validate: (value) =>
                                        (!isNaN(value) && value > 0) ||
                                        "quantity must be a positive number",
                                    })}
                                    // style={{ color: "black" }}
                                    // onMouseOver={(e) => {
                                    //   e.target.style.color = "#007bff";
                                    //   e.target.style.textDecoration =
                                    //     "underline";
                                    // }}
                                    // onMouseOut={(e) => {
                                    //   e.target.style.color = "black";
                                    //   e.target.style.textDecoration = "none";
                                    // }}
                                    required
                                  />
                                  {errors.items &&
                                    errors.items[index]?.quantity && (
                                      <span className="si-err">
                                        {errors.items[index].quantity.message}
                                      </span>
                                    )}
                                </td>
                                <td className="n">
                                  <input
                                    type="text"
                                    inputMode="decimal"
                                    className="si-cellin"
                                    {...register(`items[${index}].price`, {
                                      required: "price is required",
                                      validate: (value) =>
                                        (!isNaN(value) && value > 0) ||
                                        "price must be a positive number",
                                    })}
                                    // style={{ color: "black" }}
                                    // onMouseOver={(e) => {
                                    //   e.target.style.color = "#007bff";
                                    //   e.target.style.textDecoration =
                                    //     "underline";
                                    // }}
                                    // onMouseOut={(e) => {
                                    //   e.target.style.color = "black";
                                    //   e.target.style.textDecoration = "none";
                                    // }}
                                    required
                                  />
                                  {errors.items &&
                                    errors.items[index]?.price && (
                                      <span className="si-err">
                                        {errors.items[index].price.message}
                                      </span>
                                    )}
                                </td>

                                <td>
                                  <div className="si-rowacts">
                                    <Link
                                      to="#"
                                      className="si-rowbtn si-rowbtn--del confirm-text"
                                      title="Remove line"
                                      aria-label="Remove line"
                                      onClick={() => handleRemove(index)}
                                    >
                                      <Trash2 />
                                    </Link>
                                  </div>
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                      {fields?.length === 0 && (
                        <div className="si-empty">
                          <p className="big">No lines yet</p>
                          <p>Press Add line to start the opening stock.</p>
                        </div>
                      )}
                    </div>

                    <div className="si-lines-foot">
                      <span>
                        Lines <b>{fields.length}</b>
                      </span>
                      <span>
                        Qty <b>{qtyTotal}</b>
                      </span>
                    </div>
                  </section>

                  {/* ============ STATUS BAR ============ */}
                  <TermStatusBar
                    context={[
                      referenceNo ? `Ref ${referenceNo}` : null,
                      docDate ? dayjs(docDate).format("DD-MM-YYYY") : null,
                    ]}
                  />
                </div>

                {/* ============ RAIL ============ */}
                <aside className="si-rail">
                  <div className="si-rail-scroll">
                    <div className="si-card">
                      <div className="si-card-h">
                        <span>Document</span>
                        <span className="r">
                          {docDate ? dayjs(docDate).format("DD-MM-YYYY") : ""}
                        </span>
                      </div>
                      <div className="si-party">
                        <div className="nm">
                          {referenceNo || "No reference no."}
                        </div>
                        <div className="meta">
                          {referenceNo
                            ? `Entry ${watch("no") || "—"}`
                            : "Enter a reference no. to start"}
                        </div>
                      </div>
                    </div>

                    <div className="si-card">
                      <div className="si-card-h">Summary</div>
                      <div className="si-tot">
                        <div className="si-tr">
                          <span className="l">Lines</span>
                          <span className="v">{fields.length}</span>
                        </div>
                        <div className="si-tr">
                          <span className="l">Qty</span>
                          <span className="v">{qtyTotal}</span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="si-actions">
                    <button className="si-btn si-btn--primary" type="submit">
                      <Check />
                      <span>Save</span>
                    </button>
                  </div>
                </aside>
              </div>
            </form>
          </div>
        </div>
        {/* react-select menus portal here so they inherit the .si-term tokens */}
        <div ref={setMenuHost} className="si-menu-host" />
      </div>
    </div>
  );
};
export default OpeningStockModal;
